import React, { useContext, useEffect, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Typography,
} from "@material-ui/core";

import AssignmentTurnedInOutlinedIcon from "@material-ui/icons/AssignmentTurnedInOutlined";
import CloseIcon from "@material-ui/icons/Close";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import EventBusyOutlinedIcon from "@material-ui/icons/EventBusyOutlined";
import ExpandLessOutlinedIcon from "@material-ui/icons/ExpandLessOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MenuBookOutlinedIcon from "@material-ui/icons/MenuBookOutlined";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import SubjectOutlinedIcon from "@material-ui/icons/SubjectOutlined";

import moment from "moment";
import { useSnackbar } from "notistack";

import {
  disponibilizar,
  disponibilizarPorAtuacao,
  encerrarPreenchimentoGeral,
  estenderPrazo,
} from "../../../../services/preenchimentoFormulario/PreenchimentoFormularioService";
import { vincularFormulario } from "../../../../services/reuniao/ReuniaoService";


import FormulariosList from "../../../shared/formulario/formulariosList";
import DialogDataInicioFim from "../../dialogDataInicioFim";

import useStyles from "./useStyles";
import globalUseStyles from "../../../../styles";
import DialogConfirmacao from "../../dialogConfirmacao";
import AccordionRespostas from "../../accordionRespostas";
import { AppContext } from "../../../shared/context";

const FormularioSumulaButtons = (props) => {
  const { dados = null, updateDados } = props;
  const { role, roleSelecionada } = useContext(AppContext);

  const { enqueueSnackbar } = useSnackbar();

  const classes = useStyles();
  const globalClasses = globalUseStyles();

  const handleDisabledButtons = (requiredMessage = null) => {
    let defaultMessage =
      "Um formulário precisa ser vinculado para esta ação está disponível";
    const message = requiredMessage ? requiredMessage : defaultMessage;

    enqueueSnackbar(message, {
      variant: "warning",
    });
  };

  const [buttonVincularFormulario, setButtonVincularFormulario] =
    useState(false);
  const [openVincularFormulario, setOpenVincularFormulario] = useState(false);

  const initialFormularioVinculado = {
    idFormulario: 0,
    nomeFormulario: null,
  };
  const [formularioVinculadoLocal, setFormularioVinculadoLocal] = useState(
    initialFormularioVinculado
  );

  const handleButtonVincular = () => {
    vincularFormulario(dados.id, formularioVinculadoLocal.idFormulario).then(
      (response) => {
        if (response && response.status === 200) {
          const dadosFormularios = {
            formulario: {
              ...dados.formulario,
              id: formularioVinculadoLocal.idFormulario,
              nome: formularioVinculadoLocal.nomeFormulario,
            },
          };
          enqueueSnackbar("Formulário vinculado a reunião", {
            variant: "success",
          });
          // handleButtonVincularFormularioClose();
          setOpenVincularFormulario(false);

          // updateDados({ ...dados, ...dadosFormularios });
          updateDados((prevDados) => ({ ...prevDados, ...dadosFormularios }));
        } else {
          enqueueSnackbar("Ocorreu um erro", { variants: "error" });
        }
      }
    );
  };

  const [openVisualizarSumula, setOpenVisualizarSumula] = useState(false);
  const [exportarSumulaAnchorElement, setExportarSumulaAnchorElement] =
    useState(null);
  const isMenuExportarSumulaOpen = Boolean(exportarSumulaAnchorElement);
  const [estadosSumulaAnchorElement, setEstadosSumulaAnchorElement] =
    useState(null);
  const isMenuEstadosSumulaOpen = Boolean(estadosSumulaAnchorElement);

  const handleMenuEstadosSumulaClose = () => {
    setEstadosSumulaAnchorElement(null);
  };

  const handleMenuExportarSumulaOpen = (event) => {
    setExportarSumulaAnchorElement(event.currentTarget);
  };

  const handleMenuExportarSumulaClose = (event) => {
    setExportarSumulaAnchorElement(null);
  };

  const menuExportarSumula = () => {
    return (
      <Menu
        anchorEl={exportarSumulaAnchorElement}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        keepMounted
        transformOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={isMenuExportarSumulaOpen}
        onClose={handleMenuExportarSumulaClose}
      >
        <MenuItem>
          <InputAdornment position="start">
            <PictureAsPdfIcon style={{ cursor: "pointer" }} />
          </InputAdornment>
          PDF
        </MenuItem>
        <MenuItem>
          <InputAdornment position="start">
            <DescriptionOutlinedIcon style={{ cursor: "pointer" }} />
          </InputAdornment>
          Ms Word (*.doc)
        </MenuItem>
        <MenuItem>
          <InputAdornment position="start">
            <SubjectOutlinedIcon style={{ cursor: "pointer" }} />
          </InputAdornment>
          Texto
        </MenuItem>
      </Menu>
    );
  };

  const menuEstadosSumula = () => {
    return (
      <Menu
        anchorEl={estadosSumulaAnchorElement}
        anchorOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
        keepMounted
        transformOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={isMenuEstadosSumulaOpen}
        onClose={handleMenuEstadosSumulaClose}
      >
        {/* {respostasFormularioPorEstado.map((estado, index) => ( */}
        {dados?.formulario?.preenchimentos.map((estado, index) => (
          <MenuItem key={index}>{"SEBRAE/" + estado.ufAtuacao}</MenuItem>
        ))}
      </Menu>
    );
  };

  const handleButtonVincularFormularioOpen = () => {
    // if (nomeFormulario != null && idFormulario != null) {
    if (dados.formulario?.id) {
      // if (nomeFormulario && idFormulario) {
      setFormularioVinculadoLocal({
        idFormulario: dados.formulario.id,
        // nome: dados.formulario.nome,
      });
    }

    setOpenVincularFormulario(true);
  };

  const handleButtonVisualizarSumulaOpen = () => {
    setOpenVisualizarSumula(true);
  };

  const [
    buttonVisualizarSumulaHabilitado,
    setButtonVisualizarSumulaHabilitado,
  ] = useState(false);

  const [buttonEstadosHabilitado, setButtonEstadosHabilitado] = useState(false);
  const [estadosAnchorElement, setEstadosAnchorElement] = useState(null);
  const isMenuEstadosOpen = Boolean(estadosAnchorElement);

  const menuEstados = () => {
    return (
      // vertical: "bottom",
      <Menu
        anchorEl={estadosAnchorElement}
        anchorOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
        keepMounted
        transformOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={isMenuEstadosOpen}
        // onClose={handleMenuEstadosClose}
        onClose={() => setEstadosAnchorElement(null)}
      >
        {/* {dados?.formulario?.preenchimentos?.length > 0 && */}
        {/* {respostasFormularioPorEstado.map((estado, index) => ( */}
        {dados?.formulario?.preenchimentos.map((estado, index) => (
          <MenuItem key={index}
            onClick={() => {
              const element = document.getElementById(estado.ufAtuacao)
              if(element)
                setEstadosAnchorElement(null)
                element.scrollIntoView({behavior: 'smooth'})
            }}>
            {"SEBRAE/" + estado.ufAtuacao}
          </MenuItem>
        ))}
      </Menu>
    );
  };

  const [acoesAnchorElement, setAcoesAnchorElement] = useState(null);
  const isMenuAcoesOpen = Boolean(acoesAnchorElement);

  const [
    buttonAcoesDisponibilizarHabilitado,
    setButtonAcoesDisponibilizarHabilitado,
  ] = useState(false);
  const [
    buttonAcoesEstenderPrazoHabilitado,
    setButtonAcoesEstenderPrazoHabilitado,
  ] = useState(false);
  const [buttonAcoesEncerrarHabilitado, setButtonAcoesEncerrarHabilitado] =
    useState(false);
  const [
    buttonAcoesEnviarAlertaHabilitado,
    setButtonAcoesEnviarAlertaHabilitado,
  ] = useState(false);

  const menuAcoes = () => {
    return (
      <Menu
        anchorEl={acoesAnchorElement}
        anchorOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMenuAcoesOpen}
        // onClose={handleMenuAcoesClose}
        onClose={() => setAcoesAnchorElement(null)}
      >
        <MenuItem disabled>Disponibilidade</MenuItem>
        <MenuItem
          onClick={
            buttonAcoesDisponibilizarHabilitado
              ? () => handleMenuItemDataInicioFimOpen("disponibilizar")
              : () => handleDisabledButtons()
          }
          className={
            buttonAcoesDisponibilizarHabilitado
              ? ""
              : classes.menuItemDisabledSemFormulario
          }
          data-testid={
            buttonAcoesDisponibilizarHabilitado
              ? "button-acoes-disponibilizar-enabled"
              : "button-acoes-disponibilizar-disabled"
          }
        >
          <InputAdornment position="start">
            <AssignmentTurnedInOutlinedIcon style={{ cursor: "pointer" }} />
          </InputAdornment>
          Disponibilizar
        </MenuItem>
        <Divider />
        <MenuItem disabled>Prazos</MenuItem>
        <MenuItem
          onClick={
            buttonAcoesEstenderPrazoHabilitado
              ? () => handleMenuItemDataInicioFimOpen("estenderPrazo")
              : () => handleDisabledButtons()
          }
          className={
            buttonAcoesEstenderPrazoHabilitado
              ? ""
              : classes.menuItemDisabledSemFormulario
          }
          data-testid={
            buttonAcoesEstenderPrazoHabilitado
              ? "button-acoes-estender-enabled"
              : "button-acoes-estender-disabled"
          }
        >
          <InputAdornment position="start">
            <DateRangeOutlinedIcon style={{ cursor: "pointer" }} />
          </InputAdornment>
          Estender prazo de preenchimento
        </MenuItem>
        <MenuItem
          onClick={
            buttonAcoesEncerrarHabilitado
              ? () => handleMenuItemConfirmacaoFimOpen("encerrarPreenchimento")
              : () => handleDisabledButtons()
          }
          className={
            buttonAcoesEncerrarHabilitado
              ? ""
              : classes.menuItemDisabledSemFormulario
          }
          data-testid={
            buttonAcoesEncerrarHabilitado
              ? "button-acoes-encerrar-enabled"
              : "button-acoes-encerrar-disabled"
          }
        >
          <InputAdornment position="start">
            <EventBusyOutlinedIcon style={{ cursor: "pointer" }} />
          </InputAdornment>
          Encerrar preenchimento
        </MenuItem>
        <Divider />
        <MenuItem disabled>Enviar</MenuItem>
        <MenuItem
          onClick={
            buttonAcoesEnviarAlertaHabilitado
              ? () =>
                  handleMenuItemConfirmacaoFimOpen("enviarAlertaPreenchimento")
              : () => handleDisabledButtons()
          }
          className={
            buttonAcoesEnviarAlertaHabilitado
              ? ""
              : classes.menuItemDisabledSemFormulario
          }
          data-testid={
            buttonAcoesEnviarAlertaHabilitado
              ? "button-acoes-enviar-enabled"
              : "button-acoes-enviar-disabled"
          }
        >
          <InputAdornment position="start">
            <EmailOutlinedIcon style={{ cursor: "pointer" }} />
          </InputAdornment>
          Enviar alerta de preenchimento
        </MenuItem>
      </Menu>
    );
  };

  const [openDataInicioFim, setOpenDataInicioFim] = useState(false);
  const [openDataInicioFimTitulo, setOpenDataInicioFimTitulo] = useState({
    titulo: "",
    subtitulo: "",
  });
  const [openDataInicioFimOnSubmit, setOpenDataInicioFimOnSubmit] =
    useState("");

  const handleButtonDataInicioFimSalvar = (dataInicio, dataLimite) => {

    const dataInicioHoraInicio = moment(dataInicio)
      .startOf("day")
      .format("YYYY-MM-DDTHH:mm:ss");
    const dataLimiteHoraFim = moment(dataLimite)
      .endOf("day")
      .format("YYYY-MM-DDTHH:mm:ss");

    if (openDataInicioFimOnSubmit == "disponibilizar") {
      if(role == "ROLE_EQUIPE_TECNICA"){
        disponibilizar(dados.id, {
          dataInicio: dataInicioHoraInicio,
          dataLimite: dataLimiteHoraFim,
        }).then((response) => {
          if (response && response.status === 200) {
            enqueueSnackbar("Formulário disponibilizado na reunião", {
              variant: "success",
            });
            handleButtonDataInicioFimCancelar();

            updateDados((prevDados) => ({
              ...prevDados,
              formulario: {
                ...prevDados.formulario,
                status: "DISPONIBILIZADO",
                dataInicio: dataInicioHoraInicio,
                dataLimite: dataLimiteHoraFim,
              },
            }));
          } else {
            enqueueSnackbar("Ocorreu um erro ao disponibilizar este formulário", {
              variant: "error",
            });
          }
        });
      } else {
        disponibilizarPorAtuacao(dados.id, roleSelecionada.id, {
          dataInicio: dataInicioHoraInicio,
          dataLimite: dataLimiteHoraFim,
        }).then((response) => {
          if (response && response.status === 200) {
            enqueueSnackbar("Formulário disponibilizado na reunião", {
              variant: "success",
            });
            handleButtonDataInicioFimCancelar();

            updateDados((prevDados) => ({
              ...prevDados,
              formulario: {
                ...prevDados.formulario,
                status: "DISPONIBILIZADO",
                dataInicio: dataInicioHoraInicio,
                dataLimite: dataLimiteHoraFim,
              },
            }));
          } else {
            enqueueSnackbar("Ocorreu um erro ao disponibilizar este formulário", {
              variant: "error",
            });
          }
        });
      }
    } else if (openDataInicioFimOnSubmit == "estenderPrazo") {
      estenderPrazo(dados.id, {
        dataInicio: dataInicioHoraInicio,
        dataLimite: dataLimiteHoraFim,
      }).then((response) => {
        if (response && response.status === 200) {
          enqueueSnackbar("Prazo do Formulário estendido na reunião", {
            variant: "success",
          });
          handleButtonDataInicioFimCancelar();

          updateDados((prevDados) => ({
            ...prevDados,
            formulario: {
              ...prevDados.formulario,
              status: "DISPONIBILIZADO",
              dataInicio: dataInicioHoraInicio,
              dataLimite: dataLimiteHoraFim,
            },
          }));
        } else {
          enqueueSnackbar(
            "Ocorreu um erro ao estender o prazo deste formulário",
            {
              variant: "error",
            }
          );
        }
      });
    } else {
      enqueueSnackbar("Ocorreu um erro - ação desconhecida", {
        variant: "error",
      });
    }
  };

  const handleButtonDataInicioFimCancelar = () => {
    setOpenDataInicioFim(false);
  };
  const handleMenuItemDataInicioFimOpen = (titulo) => {
    const dataInicioFim = {
      disponibilizar: {
        titulo: "Disponibilizar",
        subtitulo: "Datas de preenchimento",
      },
      estenderPrazo: {
        titulo: "Estender Prazo de preenchimento",
        subtitulo: "Datas de preenchimento",
      },
    };

    setOpenDataInicioFimTitulo(dataInicioFim[titulo]);
    setOpenDataInicioFimOnSubmit(titulo);
    setOpenDataInicioFim(true);
  };

  const [openConfirmacao, setOpenConfirmacao] = useState(false);
  const [openConfirmacaoMensagens, setOpenConfirmacaoMensagens] = useState({});
  const [
    openConfirmacaoMensagensOnSubmit,
    setOpenConfirmacaoMensagensOnSubmit,
  ] = useState("");

  const handleMenuItemConfirmacaoFimOpen = (titulo) => {
    const confirmacao = {
      encerrarPreenchimento: {
        titulo: "Encerrar preenchimento",
        mensagem: "Isso suspenderá temporariamente o preenchimento",
        subMensagem: "Você confirma esta pausa?",
      },
      enviarAlertaPreenchimento: {
        titulo: "Enviar alerta de preenchimento",
        mensagem:
          "Isso enviará o email de aviso para o preenchimento do formulários",
      },
    };

    setOpenConfirmacaoMensagens(confirmacao[titulo]);
    setOpenConfirmacaoMensagensOnSubmit(titulo);
    setOpenConfirmacao(true);
  };

  const handleButtonConfirmacaoConfirmar = () => {
    if (openConfirmacaoMensagensOnSubmit == "encerrarPreenchimento") {
      encerrarPreenchimentoGeral(dados.id).then((response) => {
        if (response && response.status == 200) {
          enqueueSnackbar(
            "Encerrado o preenchimento do formulário com sucesso",
            {
              variant: "success",
            }
          );

          // updateDados({ ...dados, ...datasSumula });
          updateDados((prevDados) => ({
            ...prevDados,
            formulario: {
              ...prevDados.formulario,
              status: "ENCERRADO",
            },
          }));
        } else if (response && response.status == 400) {
          // Ocorreu um erro ao encerrar o preenchimento
          enqueueSnackbar(response.status, {
            variant: "error",
          });
        } else {
          enqueueSnackbar("Ocorreu um erro ao encerrar o preenchimento", {
            variant: "error",
          });
        }
      });
    } else if (
      openConfirmacaoMensagensOnSubmit == "enviarAlertaPreenchimento"
    ) {
      alert("Envio realizado - Ajustes necessários");
    } else {
      enqueueSnackbar("Ocorreu um erro - ação desconhecida", {
        variant: "error",
      });
    }

    setOpenConfirmacao(false);
    // handleMenuAcoesClose();
    setAcoesAnchorElement(null);
  };

  const handleButtonConfirmacaoCancelar = () => {
    setOpenConfirmacao(false);
    // handleMenuAcoesClose();
    setAcoesAnchorElement(null);
  };

  const checarStatusVincularFormulario = (dadosLocal) => {
    if (
      dadosLocal?.formulario?.status?.toString().toUpperCase() ==
        "DISPONIBILIZADO" ||
      dadosLocal?.formulario?.status?.toString().toUpperCase() == "ENCERRADO"
    ) {
      setButtonVincularFormulario(false);
    } else {
      setButtonVincularFormulario(true);
    }
  };

  const checarStatusVisualizarSumula = (dadosLocal) => {
    if (dadosLocal?.formulario?.id == null) {
      setButtonVisualizarSumulaHabilitado(false);
    } else if (
      dadosLocal?.formulario?.status?.toString().toUpperCase() ==
        "DISPONIBILIZADO" ||
      dadosLocal?.formulario?.status?.toString().toUpperCase() == "ENCERRADO"
    ) {
      setButtonVisualizarSumulaHabilitado(true);
    }
  };

  const checarStatusEstados = (dadosLocal) => {
    if (dadosLocal?.formulario?.id == null) {
      setButtonEstadosHabilitado(false);
    } else if (
      dadosLocal?.formulario?.status?.toString().toUpperCase() ==
        "DISPONIBILIZADO" ||
      dadosLocal?.formulario?.status?.toString().toUpperCase() == "ENCERRADO"
    ) {
      setButtonEstadosHabilitado(true);
    }
  };

  const checarStatusAcoesDisponibilizar = (dadosLocal) => {
    if (dadosLocal?.formulario.id) {
      if (
        dadosLocal?.formulario?.status?.toString().toUpperCase() ==
          "DISPONIBILIZADO" ||
        dadosLocal?.formulario?.status?.toString().toUpperCase() == "ENCERRADO"
      ) {
        setButtonAcoesDisponibilizarHabilitado(false);
      } else {
        setButtonAcoesDisponibilizarHabilitado(true);
      }
    } else {
      setButtonAcoesDisponibilizarHabilitado(false);
    }
  };

  const checarStatusAcoesEstenderPrazo = (dadosLocal) => {
    if (
      dadosLocal?.formulario.id &&
      dadosLocal?.formulario?.status?.toString().toUpperCase() ==
        "DISPONIBILIZADO"
    ) {
      setButtonAcoesEstenderPrazoHabilitado(true);
    } else {
      setButtonAcoesEstenderPrazoHabilitado(false);
    }
  };

  const checarStatusAcoesEncerrar = (dadosLocal) => {
    if (
      dadosLocal?.formulario.id &&
      dadosLocal?.formulario?.status?.toString().toUpperCase() ==
        "DISPONIBILIZADO"
    ) {
      setButtonAcoesEncerrarHabilitado(true);
    } else {
      setButtonAcoesEncerrarHabilitado(false);
    }
  };

  const checarStatusAcoesEnviar = (dadosLocal) => {
    if (
      dadosLocal?.formulario.id &&
      dadosLocal?.formulario?.status?.toString().toUpperCase() ==
        "DISPONIBILIZADO"
    ) {
      setButtonAcoesEnviarAlertaHabilitado(true);
    } else {
      setButtonAcoesEnviarAlertaHabilitado(false);
    }
  };

  useEffect(() => {
    checarStatusVincularFormulario(dados);
    checarStatusVisualizarSumula(dados);
    checarStatusEstados(dados);
    checarStatusAcoesDisponibilizar(dados);
    checarStatusAcoesEstenderPrazo(dados);
    checarStatusAcoesEncerrar(dados);
    checarStatusAcoesEnviar(dados);
  }, []);

  useEffect(() => {
    checarStatusVincularFormulario(dados);
    checarStatusVisualizarSumula(dados);
    checarStatusEstados(dados);
    checarStatusAcoesDisponibilizar(dados);
    checarStatusAcoesEstenderPrazo(dados);
    checarStatusAcoesEncerrar(dados);
    checarStatusAcoesEnviar(dados);
  }, [
    dados?.formulario?.id,
    dados?.formulario?.status,
    dados?.formulario?.dataInicio,
    dados?.formulario?.dataLimite,
  ]);

  return (
    <>
      <Button
        onClick={
          buttonVincularFormulario
            ? handleButtonVincularFormularioOpen
            : () => handleDisabledButtons("Esta ação está indisponível")
        }
        className={buttonVincularFormulario ? "" : classes.buttonDisabled}
        variant="outlined"
        data-testid={
          buttonVincularFormulario
            ? "button-vincular-formulario-enabled"
            : "button-vincular-formulario-disabled"
        }
      >
        <AssignmentTurnedInOutlinedIcon />
        Vincular formulário
      </Button>
      <Button
        onClick={
          buttonVisualizarSumulaHabilitado
            ? handleButtonVisualizarSumulaOpen
            : () => handleDisabledButtons()
        }
        variant="outlined"
        className={
          buttonVisualizarSumulaHabilitado ? "" : classes.buttonDisabled
        }
        data-testid={
          buttonVisualizarSumulaHabilitado
            ? "button-visualizar-sumula-enabled"
            : "button-visualizar-sumula-disabled"
        }
      >
        <MenuBookOutlinedIcon />
        Visualizar súmula
      </Button>
      <Button
        id="estados"
        name="estados"
        onClick={
          buttonEstadosHabilitado
            ? // ? (event) => handleMenuEstadosOpen(event)
              (event) => setEstadosAnchorElement(event.currentTarget)
            : () => handleDisabledButtons()
        }
        variant="outlined"
        className={buttonEstadosHabilitado ? "" : classes.buttonDisabled}
        data-testid={
          buttonEstadosHabilitado
            ? "button-estados-enabled"
            : "button-estados-disabled"
        }
      >
        Estados
        <ExpandMoreIcon />
      </Button>
      <Button
        id="acoes"
        name="acoes"
        // onClick={(event) => handleMenuAcoesOpen(event)}
        onClick={(event) => setAcoesAnchorElement(event.currentTarget)}
        variant="outlined"
      >
        Ações
        <ExpandMoreIcon />
      </Button>

      {openVincularFormulario && (
        <Dialog
          open={openVincularFormulario}
          onClose={() => setOpenVincularFormulario(false)}
          fullWidth
          maxWidth="xl"
        >
          <DialogTitle>
            <Typography paragraph className={globalClasses.tituloDialog}>
              Vincular formulário
            </Typography>
            <IconButton
              className={globalClasses.closeButtonDialog}
              onClick={() => setOpenVincularFormulario(false)}
              // onClick={handleButtonVincularFormularioClose}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <FormulariosList
              mostrarColunaMenuAcoes={false}
              mostrarColunaSelecionar
              formularioVinculoSelecionado={formularioVinculadoLocal}
              onSetFormularioSelecionado={setFormularioVinculadoLocal}
            />
          </DialogContent>
          <DialogActions
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Button variant="contained" onClick={handleButtonVincular}>
              Vincular
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setOpenVincularFormulario(false)}
            >
              Cancelar
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {openVisualizarSumula && (
        <>
          <Dialog
            open={openVisualizarSumula}
            onClose={() => setOpenVisualizarSumula(false)}
            // onClose={handleButtonVisualizarSumulaClose}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle>
              <Typography paragraph className={globalClasses.tituloDialog}>
                Visualização de Súmula
              </Typography>
              <IconButton
                className={globalClasses.closeButtonDialog}
                onClick={() => setOpenVisualizarSumula(false)}
                // onClick={handleButtonVisualizarSumulaClose}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Grid className={classes.gridSumulaDialogContents}>
                <Typography className={classes.sumulaTypography}>
                  Súmula - Agosto de 2023
                </Typography>
                <Grid>
                  <Typography className={classes.typographySumulaTitulo}>
                    SÚMULA DAS REUNIÕES DOS
                    <br />
                    CONSELHOS DELIBERATIVOS ESTADUAIS
                  </Typography>
                </Grid>
                <Grid className={classes.gridSumulaDatas}>
                  <Grid>
                    <Typography className={classes.typographySumulaTitulos}>
                      Formulário disponibilizado 00/00/0000
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography className={classes.typographySumulaTitulos}>
                      Prazo final 00/00/0000
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid className={classes.gridSumulaMainContent}>
                <Typography
                  component="div"
                  style={{
                    alignSelf: "flex-start",
                  }}
                >
                  Capa
                </Typography>
                <Typography
                  component="div"
                  style={{
                    textAlign: "center",
                    fontSize: "23px",
                    fontWeight: "400",
                  }}
                >
                  Conselho Deliberativo Nacional
                  <br />
                  Gabinete da Presidência
                </Typography>
                <Typography component="div" className={classes.sumulaSubTitulo}>
                  Súmula das Reuniões dos Conselhos Deliberativos Estaduais
                </Typography>
                <Typography component="div">FEVEREIRO/2023</Typography>
              </Grid>
              {/* {accordionEstados()} */}
              <AccordionRespostas respostas={dados.formulario.preenchimentos}/>
            </DialogContent>
            <DialogActions
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Grid>
                <Grid>
                  <Button
                    onClick={() => alert("Abriu comentários")}
                    variant="outlined"
                  >
                    <SearchOutlinedIcon />
                    Comentários da súmula
                  </Button>
                </Grid>
              </Grid>
              <Grid>
                <Grid>
                  <Button
                    onClick={(event) => handleMenuExportarSumulaOpen(event)}
                    variant="outlined"
                  >
                    Exportar
                    <ExpandLessOutlinedIcon />
                  </Button>
                  <Button
                    onClick={(event) => handleMenuEstadosSumulaOpen(event)}
                    variant="outlined"
                  >
                    Estados
                    <ExpandLessOutlinedIcon />
                  </Button>
                </Grid>
              </Grid>
            </DialogActions>
          </Dialog>

          {menuEstadosSumula()}
          {menuExportarSumula()}
        </>
      )}
      {dados?.formulario?.preenchimentos?.length > 0 && menuEstados()}
      {menuAcoes()}

      {openDataInicioFim && (
        <DialogDataInicioFim
          open={openDataInicioFim}
          onClose={handleButtonDataInicioFimCancelar}
          tituloSubtitulo={openDataInicioFimTitulo}
          onSubmitExternal={handleButtonDataInicioFimSalvar}
          dataInicioFornecida={dados.formulario.dataInicio}
          dataFimFornecida={dados.formulario.dataLimite}
          isDisponibilizar={!!(openDataInicioFimOnSubmit == 'disponibilizar')}
        />
      )}
      {openConfirmacao && (
        <DialogConfirmacao
          open={openConfirmacao}
          onClose={handleButtonConfirmacaoCancelar}
          tituloSubtitulo={openConfirmacaoMensagens}
          onConfirmar={handleButtonConfirmacaoConfirmar}
        />
      )}
    </>
  );
};

export default FormularioSumulaButtons;
